import { useEffect, useRef, type ReactNode } from 'react';
import { IconClose } from '../../lib/icons.tsx';

interface Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}

export function Modal({ title, onClose, children, footer, wide }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    // 모달이 열리면 첫 포커스 가능한 요소로 이동 (접근성)
    const focusable = ref.current?.querySelector<HTMLElement>(
      'input, button, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    focusable?.focus();
    return () => { window.removeEventListener('keydown', onKey); };
  }, [onClose]);

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        ref={ref}
        className={wide ? 'modal modal--wide' : 'modal'}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="row">
          <h2 className="modal__title spacer">{title}</h2>
          <button className="btn btn--ghost btn--icon" aria-label="닫기" onClick={onClose}>
            <IconClose size={16} />
          </button>
        </div>
        {children}
        {footer && <div className="modal__actions">{footer}</div>}
      </div>
    </div>
  );
}
